import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';

const Layout = () => {
  return (
    <PXFormModalWrapper>
      <FDStack direction="column" spacing={1}>
        <MetaControlField attr="description" />
        <MetaControlField attr="corrections" />
      </FDStack>
    </PXFormModalWrapper>
  );
};

export default Layout;
